import script from "./TimeIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeIndicator.vue?vue&type=script&setup=true&lang=js"

import "./TimeIndicator.vue?vue&type=style&index=0&id=19c01225&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c01225"]])

export default __exports__